export default __webpack_public_path__ + "static/media/logotype.891de007.svg";